import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CreateUser from './pages/CreateUser';
import LoginUser from './pages/LoginUser';
import Posts from './pages/Posts';
import CreatePosts from './pages/CreatePosts'
import {AuthProvider} from './context/AuthContext';
import Dashboard from './pages/Dashboard';
import CreateRoom from './pages/CreateRoom';
import JoinRoom from './pages/JoinRoom';
import BizzNews from './pages/BizzNews';
import theme from './utils/themes';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import UniversalGPT from './pages/UniversalGPT';
import WhatsAppGPT from './pages/WhatsAppGPT';
import Wikipedia from './pages/Wikipedia';
import Pdf from './pages/Pdf';
import Youtube from './pages/Youtube';
import BizzBoard from './pages/bizzboard/BizzBoard';
import DataUpload from './pages/DataUpload';
import CssBaseline from '@mui/material/CssBaseline';
import BizzFlow from './pages/BizzFlow';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';

const App = () => {
  const [accessToken, setAccessToken] = useState('');

  return (
    <div style={{ margin: 0 }}>
      <CssBaseline />
    <ThemeProvider theme={theme}>
      <AuthProvider >
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginUser />} />
            {/* <Route path="/posts" element={<Posts />} /> */}
            <Route path="/create_user" element={<CreateUser />} />
            <Route path="/create_posts" element={<CreatePosts />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/bizzboard" element={<ProtectedRoute><DataUpload /></ProtectedRoute>} />
            <Route path="/show_bizzboard" element={<ProtectedRoute><BizzBoard/></ProtectedRoute>}/>
            <Route path="/create_room" element={<ProtectedRoute><CreateRoom /></ProtectedRoute>} />
            <Route path="/join_room" element={<ProtectedRoute><JoinRoom /></ProtectedRoute>} />
            <Route path="/bizznews" element={<ProtectedRoute><BizzNews /></ProtectedRoute>} />
            <Route path="/bizzflow" element={<ProtectedRoute><BizzFlow /></ProtectedRoute>} />
            <Route path="/universal_gpt" element={<UniversalGPT />} />
            <Route path="/universal_gpt/whatsapp" element={<WhatsAppGPT />} />
            <Route path="/universal_gpt/wikipedia" element={<Wikipedia />} />
            <Route path="/universal_gpt/pdf" element={<Pdf />} />
            <Route path="/universal_gpt/youtube" element={<Youtube />} />
            {/* <Route path="/universal_gpt/outlook" element={<Outlook />} />
            <Route path="/graph_room/:room_id" element={<GraphRoom />} /> */}
          </Routes>
        </Router>
      </AuthProvider>

    </ThemeProvider>
    </div>
  );
};

export default App;
